import React, { Component } from 'react';
import moment from 'moment';
import * as ScrollMagic from 'scrollmagic';

import config from '@config';
import DateElement from './dateelement';
import Timeline from './timeline';
import { scrollGridForDuration } from '@tvguide/helpers';

const timeLimit = new Array(7).fill('');

class DateTimeline extends Component {
  constructor(props) {
    super(props);
    this.timeline = React.createRef();

    this.state = {
      isScrollDisabled: false,
    };
  }

  componentDidMount() {
    if (window.innerWidth < config.breakpoints.tablet) {
      let totalWidth = 0;
      for (let i = 0; i < this.timeline.current.children.length; i++) {
        totalWidth += this.timeline.current.children[i].offsetWidth;
      }

      this.timeline.current.scrollLeft = (totalWidth - window.innerWidth) / 2;
    }

    window.addEventListener(
      config.events.renderedGrid,
      this.initScrollMagic.bind(this),
    );
    window.addEventListener(
      config.events.changeView,
      this.destroyScrollMagic.bind(this),
    );
  }

  componentWillUnmount() {
    window.removeEventListener(
      config.events.renderedGrid,
      this.initScrollMagic,
    );
    window.removeEventListener(
      config.events.changeView,
      this.destroyScrollMagic.bind(this),
    );
  }

  componentDidUpdate() {
    if (this.smController) {
      this.initScrollMagic();
    }
  }

  getTvGuideContainer() {
    switch (this.props.view) {
      case 'grid':
        return document.querySelector('.tvg-grid__container');
      case 'list':
        return document.querySelector('.tvg-list-view__container');
      case 'text':
        return document.querySelector('.tvg-text-view');
      default:
        return document.querySelector('.tvg-grid__container');
    }
  }

  initScrollMagic() {
    if (this.smController) {
      return;
    }

    // Get current view before ScrollMagic initialization.
    const targetContainer = this.getTvGuideContainer();
    if (!targetContainer) {
      return;
    }

    this.smController = new ScrollMagic.Controller({
      refreshInterval: 0,
    });

    if (this.state.isScrollDisabled) {
      return;
    }

    // Put a duration of 0 (default value) to the scene because we don't know the final targetContainer height at this point
    const stickyScene = new ScrollMagic.Scene({
      triggerElement: '.fv-fixed-scroll',
      triggerHook: 0,
    });
    stickyScene.setPin('.fv-fixed-scroll', {
      pushFollowers: false,
    });
    stickyScene.on('progress', function(event) {
      if (event.scrollDirection === 'FORWARD') {
        $('.fv-fixed-scroll').css('top', '-65px');
      } else if (event.scrollDirection === 'REVERSE') {
        $('.fv-fixed-scroll').css('top', 0);
      }
      // Set scene duration here in case the targetContainer change height because of dynamic content
      if (stickyScene.duration() < targetContainer.offsetHeight) {
        stickyScene.duration(targetContainer.offsetHeight);
      }
    });
    stickyScene.addTo(this.smController);

    window.addEventListener(
      'scroll-disabled',
      (e => {
        stickyScene.removePin(true);
        this.setState({ isScrollDisabled: true });
      }).bind(this),
    );
    window.addEventListener(
      'scroll-enabled',
      (e => {
        this.setState({ isScrollDisabled: false });
      }).bind(this),
    );

    if (window.innerWidth <= config.breakpoints.mobile) {
      const timelineContainer = document.querySelector('.tvg-date-timeline');
      const todayElement = timelineContainer.querySelector('.active');
      timelineContainer.scrollLeft =
        todayElement.getBoundingClientRect().x -
        window.innerWidth / 2 +
        todayElement.offsetWidth / 2;
    }
  }

  destroyScrollMagic() {
    this.smController = this.smController.destroy(true);
  }

  generateDayTimeline(day) {
    const elements = [];

    for (let i = 0; i < 24; i++) {
      let text;
      switch (true) {
        case i >= 13:
          text = `${i - 12}pm`;
          break;
        case i === 0:
          text = '12am';
          break;
        case i === 12:
          text = '12pm';
          break;
        default:
          text = `${i}am`;
          break;
      }

      const liProps = {
        key: `${day}-${i}`,
        style: { width: `${60 * this.props.minutesPixelRatio}px` },
      };

      elements.push(React.createElement('li', liProps, text));
    }

    return elements;
  }

  generateTimeline(fromDay, toDay) {
    const listElements = [];
    const now = moment();
    const daysBetween = toDay.diff(fromDay, 'days');

    for (let i = 0; i <= daysBetween; i++) {
      listElements.push(
        this.generateDayTimeline(
          fromDay
            .clone()
            .add(i, 'days')
            .format('YYYY-MM-DD'),
        ),
      );
    }

    return listElements;
  }

  render() {
    const { view } = this.props;

    return (
      <div id="date-list">
        <div className="tvg-date-timeline__container">
          <ul
            className={`tvg-date-timeline ${
              view === 'text' ? 'tvg-date-timeline--big' : ''
            }`}
            ref={this.timeline}
          >
            {timeLimit.map((el, index) => (
              <DateElement
                date={moment().subtract(timeLimit.length - index, 'days')}
                key={index}
              />
            ))}
            <DateElement date={moment()} />
            {timeLimit.map((el, index) => (
              <DateElement date={moment().add(index + 1, 'days')} key={index} />
            ))}
          </ul>
        </div>
        {this.props.view == 'grid' && <Timeline />}
      </div>
    );
  }
}

export default DateTimeline;
